import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreatePostComment(jobId: number, postId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (comment: string) =>
      postApiClient.createComment(jobId, postId, { comment }),
    onSettled: () => invalidateFor('postComment.write', qc, { jobId, postId }),
  });
}

export function useUpdatePostComment(jobId: number, postId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      commentId,
      comment,
    }: {
      commentId: string;
      comment: string;
    }) => postApiClient.updateComment(jobId, postId, commentId, { comment }),
    onSettled: () => invalidateFor('postComment.write', qc, { jobId, postId }),
  });
}

export function useDeletePostComment(jobId: number, postId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (commentId: string) =>
      postApiClient.deleteComment(jobId, postId, commentId),
    onSettled: () => invalidateFor('postComment.write', qc, { jobId, postId }),
  });
}
